import React, { Component } from 'react'
import Root from './containers/Root'
import {
  BrowserRouter,
  Route,
} from 'react-router-dom'
import ReactGA from 'react-ga'

import './styles/styles.css'
import 'react-notifications/lib/notifications.css'

class App extends Component {

  constructor (props) {
    super(props)
    
    ReactGA.initialize('UA-128386869-1')
  }

  render () {
    return (
        <BrowserRouter>
          <Route path='/' component={Root} />
        </BrowserRouter>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js